(function (cjs, an) {

var p; // shortcut to reference prototypes
var lib={};var ss={};var img={};
lib.ssMetadata = [
		{name:"index_atlas_1", frames: [[133,270,129,52],[308,54,137,52],[0,162,282,52],[0,216,272,52],[274,216,184,52],[301,108,132,52],[284,162,178,52],[0,54,306,52],[0,0,395,52],[0,108,299,52],[0,270,131,52]]}
];


(lib.AnMovieClip = function(){
	this.actionFrames = [];
	this.ignorePause = false;
	this.gotoAndPlay = function(positionOrLabel){
		cjs.MovieClip.prototype.gotoAndPlay.call(this,positionOrLabel);
	}
	this.play = function(){
		cjs.MovieClip.prototype.play.call(this);
	}
	this.gotoAndStop = function(positionOrLabel){
		cjs.MovieClip.prototype.gotoAndStop.call(this,positionOrLabel);
	}
	this.stop = function(){
		cjs.MovieClip.prototype.stop.call(this);
	}
}).prototype = p = new cjs.MovieClip();
// symbols:



(lib.CachedBmp_11 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(0);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_10 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(1);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_9 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(2);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_8 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(3);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_7 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(4);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_6 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(5);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_5 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(6);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_4 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(7);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_3 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(8);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_2 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(9);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_1 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(10);
}).prototype = p = new cjs.Sprite();
// helper functions:

function mc_symbol_clone() {
	var clone = this._cloneProps(new this.constructor(this.mode, this.startPosition, this.loop, this.reversed));
	clone.gotoAndStop(this.currentFrame);
	clone.paused = this.paused;
	clone.framerate = this.framerate;
	return clone;
}

function getMCSymbolPrototype(symbol, nominalBounds, frameBounds) {
	var prototype = cjs.extend(symbol, cjs.MovieClip);
	prototype.clone = mc_symbol_clone;
	prototype.nominalBounds = nominalBounds;
	prototype.frameBounds = frameBounds;
	return prototype;
	}


(lib.size_1920x1080 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// size
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("rgba(255,255,255,0)").beginStroke().moveTo(-960,540).lineTo(-960,-540).lineTo(960,-540).lineTo(960,540).closePath();
	this.shape.setTransform(960,540);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.size_1920x1080, new cjs.Rectangle(0,0,1920,1080), null);


(lib.size_90x90 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// size
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("rgba(255,255,255,0)").beginStroke().moveTo(-45,45).lineTo(-45,-45).lineTo(45,-45).lineTo(45,45).closePath();
	this.shape.setTransform(45,45);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.size_90x90, new cjs.Rectangle(0,0,90,90), null);


(lib.logo = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#FFFFFF").beginStroke().moveTo(-109.8,148.6).curveTo(-122.8,143.6,-132.4,134.4).curveTo(-142.1,125.2,-147.3,112.8).curveTo(-152.7,100.1,-152.7,85.5).curveTo(-152.7,70.8,-147.3,58.1).curveTo(-142.1,45.8,-132.4,36.6).curveTo(-122.6,27.3,-109.6,22.4).curveTo(-96.2,17.3,-80.9,17.3).curveTo(-64.3,17.3,-50.7,22.8).curveTo(-37.1,28.3,-27.7,38.9).lineTo(-43.3,54).curveTo(-51,46.3,-60.1,42.6).curveTo(-69,38.9,-79.8,38.9).curveTo(-90.2,38.9,-99.2,42.3).curveTo(-108,45.7,-114.4,51.9).curveTo(-120.9,58.1,-124.4,66.6).curveTo(-127.9,75.3,-127.9,85.5).curveTo(-127.9,95.4,-124.4,104.1).curveTo(-120.9,112.6,-114.5,118.9).curveTo(-108,125.2,-99.3,128.6).curveTo(-90.4,132.1,-80,132.1).curveTo(-64.5,132.1,-52.7,125.3).lineTo(-52.7,84).lineTo(-29.4,84).lineTo(-29.4,136.8).curveTo(-39.5,145,-53.5,149.4).curveTo(-66.9,153.6,-81.3,153.6).curveTo(-96.5,153.6,-109.8,148.6).closePath().moveTo(130.4,152).lineTo(84,44.1).lineTo(37.8,152).lineTo(12.4,152).lineTo(72.1,19.4).lineTo(96.3,19.4).lineTo(156.1,152).closePath().moveTo(55.5,-22.4).curveTo(42.6,-27.4,32.9,-36.7).curveTo(23.3,-45.9,18,-58.3).curveTo(12.7,-71,12.7,-85.5).curveTo(12.7,-99.9,18,-112.6).curveTo(23.3,-125,32.9,-134.2).curveTo(42.6,-143.5,55.5,-148.5).curveTo(68.8,-153.6,84,-153.6).curveTo(99.2,-153.6,112.5,-148.5).curveTo(125.5,-143.5,135.1,-134.3).curveTo(144.8,-125.1,150,-112.7).curveTo(155.4,-100,155.4,-85.5).curveTo(155.4,-70.9,150,-58.2).curveTo(144.8,-45.8,135.1,-36.6).curveTo(125.5,-27.4,112.5,-22.4).curveTo(99.2,-17.3,84,-17.3).curveTo(68.8,-17.3,55.5,-22.4).closePath().moveTo(65.5,-128.6).curveTo(57.1,-125.2,50.7,-118.9).curveTo(44.4,-112.6,40.9,-104.2).curveTo(37.4,-95.4,37.4,-85.5).curveTo(37.4,-75.5,40.9,-66.8).curveTo(44.4,-58.3,50.7,-52).curveTo(57.1,-45.7,65.5,-42.4).curveTo(74.1,-38.9,84,-38.9).curveTo(93.9,-38.9,102.5,-42.4).curveTo(111,-45.7,117.4,-52).curveTo(123.7,-58.3,127.1,-66.8).curveTo(130.6,-75.5,130.6,-85.5).curveTo(130.6,-95.4,127.1,-104.2).curveTo(123.7,-112.6,117.4,-118.9).curveTo(111,-125.2,102.5,-128.6).curveTo(93.9,-132.1,84,-132.1).curveTo(74.1,-132.1,65.5,-128.6).closePath().moveTo(-98.3,-17.3).lineTo(-156.2,-149.8).lineTo(-129.4,-149.8).lineTo(-85.3,-47.6).lineTo(-40.9,-149.8).lineTo(-16.3,-149.8).lineTo(-74,-17.3).closePath();
	this.shape.setTransform(156.15,153.625);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,312.3,307.3);


(lib.vertical = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// vertical
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill().beginStroke("#FFFFFF").setStrokeStyle(2,1,1).moveTo(0,-8).lineTo(0,8);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.vertical, new cjs.Rectangle(-1,-9,2,18), null);


(lib.square = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// square
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#FFFFFF").beginStroke().moveTo(-4,4).lineTo(-4,-4).lineTo(4,-4).lineTo(4,4).closePath();

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.square, new cjs.Rectangle(-4,-4,8,8), null);


(lib.ball = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// ball
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#FFFFFF").beginStroke().moveTo(-2.8,2.9).curveTo(-4,1.7,-4,0).curveTo(-4,-1.6,-2.8,-2.8).curveTo(-1.6,-4,0,-4).curveTo(1.6,-4,2.8,-2.8).curveTo(4,-1.6,4,0).curveTo(4,1.7,2.8,2.9).curveTo(1.6,4,0,4).curveTo(-1.6,4,-2.8,2.9).closePath();

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ball, new cjs.Rectangle(-4,-4,8,8), null);


(lib.pseudo = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// pseudo
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("rgba(255,255,255,0.498)").beginStroke().moveTo(-67.4,30).lineTo(-67.4,-30).lineTo(67.4,-30).lineTo(67.4,30).closePath();
	this.shape.setTransform(67.4,30);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.pseudo, new cjs.Rectangle(0,0,134.8,60), null);


(lib.arrow_up = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// arrow
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#DBDEC3").beginStroke().moveTo(-22.6,11.3).lineTo(-0.1,-11.3).lineTo(22.6,11.3).closePath();
	this.shape.setTransform(0,11.325);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.arrow_up, new cjs.Rectangle(-22.6,0,45.2,22.7), null);


(lib.solid = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// line
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill().beginStroke("#FFFFFF").setStrokeStyle(4,0,1).moveTo(-960,0).lineTo(960,0);
	this.shape.setTransform(960,0);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.solid, new cjs.Rectangle(-2,-2,1924,4), null);


(lib.gradient = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// line
	this.shape = new cjs.Shape();
	this.shape.graphics.beginLinearGradientFill(["#5BC3BE","#1F4F6E"],[0,1],-680,0,680,0).beginStroke().moveTo(-680,2).lineTo(-680,-2).lineTo(680,-2).lineTo(680,2).closePath();
	this.shape.setTransform(680,0);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.gradient, new cjs.Rectangle(0,-2,1360,4), null);


(lib._double = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// line
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill().beginStroke("#666666").setStrokeStyle(2,1,1).moveTo(50,-30).lineTo(-550,-30).moveTo(550,30).lineTo(-250,30);
	this.shape.setTransform(550,30);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib._double, new cjs.Rectangle(-1,-1,1102,62), null);


(lib.logo_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// logo
	this.text = new cjs.Text("Before", "200px 'Montserrat Medium'", "#FFFFFF");
	this.text.textAlign = "center";
	this.text.lineHeight = 278;
	this.text.lineWidth = 676;
	this.text.parent = this;
	this.text.setTransform(233.35,2);

	this.timeline.addTween(cjs.Tween.get(this.text).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.logo_1, new cjs.Rectangle(-106.5,0,679.7,557.6), null);


(lib.button = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// pseudo
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#FFFFFF").beginStroke().moveTo(-64,64).lineTo(-64,-64).lineTo(64,-64).lineTo(64,64).closePath();
	this.shape._off = true;

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(3).to({_off:false},0).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-64,-64,128,128);


(lib.title = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// vertical
	this.instance = new lib.vertical();
	this.instance.setTransform(1215.7,13);
	this.instance.visible = false;

	this.instance_1 = new lib.vertical();
	this.instance_1.setTransform(1071.5,13);
	this.instance_1.visible = false;

	this.instance_2 = new lib.vertical();
	this.instance_2.setTransform(833.4,13);
	this.instance_2.visible = false;

	this.instance_3 = new lib.vertical();
	this.instance_3.setTransform(634.5,13);
	this.instance_3.visible = false;

	this.instance_4 = new lib.vertical();
	this.instance_4.setTransform(1410.4,13);
	this.instance_4.visible = false;

	this.instance_5 = new lib.vertical();
	this.instance_5.setTransform(450.8,13);
	this.instance_5.visible = false;

	this.instance_6 = new lib.vertical();
	this.instance_6.setTransform(273.8,13);
	this.instance_6.visible = false;

	this.instance_7 = new lib.vertical();
	this.instance_7.setTransform(88,13);
	this.instance_7.visible = false;

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_7},{t:this.instance_6},{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]}).wait(1));

	// square
	this.instance_8 = new lib.square();
	this.instance_8.setTransform(1215.7,13);
	this.instance_8.visible = false;

	this.instance_9 = new lib.square();
	this.instance_9.setTransform(1071.5,13);
	this.instance_9.visible = false;

	this.instance_10 = new lib.square();
	this.instance_10.setTransform(833.4,13);
	this.instance_10.visible = false;

	this.instance_11 = new lib.square();
	this.instance_11.setTransform(1410.4,13);
	this.instance_11.visible = false;

	this.instance_12 = new lib.square();
	this.instance_12.setTransform(634.5,13);
	this.instance_12.visible = false;

	this.instance_13 = new lib.square();
	this.instance_13.setTransform(450.8,13);
	this.instance_13.visible = false;

	this.instance_14 = new lib.square();
	this.instance_14.setTransform(273.8,13);
	this.instance_14.visible = false;

	this.instance_15 = new lib.square();
	this.instance_15.setTransform(88,13);
	this.instance_15.visible = false;

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_15},{t:this.instance_14},{t:this.instance_13},{t:this.instance_12},{t:this.instance_11},{t:this.instance_10},{t:this.instance_9},{t:this.instance_8}]}).wait(1));

	// ball
	this.instance_16 = new lib.ball();
	this.instance_16.setTransform(1345.3,12.6);

	this.instance_17 = new lib.ball();
	this.instance_17.setTransform(1238.3,12.6);

	this.instance_18 = new lib.ball();
	this.instance_18.setTransform(1107.9,12.6);

	this.instance_19 = new lib.ball();
	this.instance_19.setTransform(1003.2,12.6);

	this.instance_20 = new lib.ball();
	this.instance_20.setTransform(875.4,12.6);

	this.instance_21 = new lib.ball();
	this.instance_21.setTransform(639.4,12.6);

	this.instance_22 = new lib.ball();
	this.instance_22.setTransform(447.8,12.6);

	this.instance_23 = new lib.ball();
	this.instance_23.setTransform(273.1,12.6);

	this.instance_24 = new lib.ball();
	this.instance_24.setTransform(84.9,12.6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_24},{t:this.instance_23},{t:this.instance_22},{t:this.instance_21},{t:this.instance_20},{t:this.instance_19},{t:this.instance_18},{t:this.instance_17},{t:this.instance_16}]}).wait(1));

	// title
	this.instance_25 = new lib.ball();
	this.instance_25.setTransform(1524.3,12.6);

	this.instance_26 = new lib.CachedBmp_11();
	this.instance_26.setTransform(1543.6,0,0.5,0.5);

	this.instance_27 = new lib.CachedBmp_10();
	this.instance_27.setTransform(1257.6,0,0.5,0.5);

	this.instance_28 = new lib.CachedBmp_9();
	this.instance_28.setTransform(1364.6,0,0.5,0.5);

	this.instance_29 = new lib.CachedBmp_8();
	this.instance_29.setTransform(292.4,0,0.5,0.5);

	this.instance_30 = new lib.CachedBmp_7();
	this.instance_30.setTransform(1127.15,0,0.5,0.5);

	this.instance_31 = new lib.CachedBmp_6();
	this.instance_31.setTransform(1022.5,0,0.5,0.5);

	this.instance_32 = new lib.CachedBmp_5();
	this.instance_32.setTransform(894.7,0,0.5,0.5);

	this.instance_33 = new lib.CachedBmp_4();
	this.instance_33.setTransform(467.1,0,0.5,0.5);

	this.instance_34 = new lib.CachedBmp_3();
	this.instance_34.setTransform(658.7,0,0.5,0.5);

	this.instance_35 = new lib.CachedBmp_2();
	this.instance_35.setTransform(104.2,0,0.5,0.5);

	this.instance_36 = new lib.CachedBmp_1();
	this.instance_36.setTransform(0,0,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_36},{t:this.instance_35},{t:this.instance_34},{t:this.instance_33},{t:this.instance_32},{t:this.instance_31},{t:this.instance_30},{t:this.instance_29},{t:this.instance_28},{t:this.instance_27},{t:this.instance_26},{t:this.instance_25}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.title, new cjs.Rectangle(0,0,1608.1,26), null);


(lib.effect_up = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {start:1,complete:10,end:19};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_0 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
	}
	this.frame_9 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
	}
	this.frame_19 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(9).call(this.frame_9).wait(10).call(this.frame_19).wait(1));

	// effect
	this.instance = new lib.arrow_up();
	this.instance._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1).to({_off:false},0).to({y:-30},4).to({y:-22.65},2).to({y:-30},2).wait(1).to({y:0},9).wait(1));

	// size
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#FFFFFF").beginStroke().moveTo(-22.6,11.3).lineTo(-0.1,-11.3).lineTo(22.6,11.3).closePath();
	this.shape.setTransform(0,11.325);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(20));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-22.6,-30,45.2,52.7);


(lib.background = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// line_solid
	this.instance = new lib.solid();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// line_gradient
	this.instance_1 = new lib.gradient();
	this.instance_1.setTransform(560,0);
	this.instance_1.visible = false;

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1));

	// line_double
	this.instance_2 = new lib._double();
	this.instance_2.visible = false;

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(1));

	// background
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#62685F").beginStroke().moveTo(-960,40).lineTo(-960,-40).lineTo(960,-40).lineTo(960,40).closePath();
	this.shape.setTransform(960,40);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.background, new cjs.Rectangle(-2,-2,1924,82), null);


(lib.logo_2 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {none:1,small:2,medium:3,large:4};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_0 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(5));

	// background
	this.instance = new lib.logo("synched",0);
	this.instance.setTransform(95.2,29.2,0.0961,0.096,0,0,0,101.4,69.2);
	this.instance._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(2).to({_off:false},0).wait(1).to({regX:101.3,scaleX:0.151,scaleY:0.1509,x:88.95,y:25.45},0).wait(1).to({regX:101,regY:69.3,scaleX:0.2232,scaleY:0.223,x:86.45,y:21.7},0).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,133.6,74.8);


(lib.background_dynamic = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {frame01:1,frame02:2,frame03:3,frame04:4,frame05:5,frame06:6,frame07:7,frame08:8,frame09:9,frame10:10,frame11:11};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_0 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(12));

	// size
	this.instance = new lib.size_1920x1080();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(12));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,1920,1080);


(lib.content_frame_01 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"start":1,"complete":30,"end":59};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_0 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
		
		/**
		 *
		 * Class reference.
		 */
		StageClass.main.scene.layerActions.effectStart('index', 'before');
	}
	this.frame_29 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
		
		/**
		 *
		 * Class reference.
		 */
		StageClass.main.scene.layerActions.effectComplete('index', 'before');
	}
	this.frame_59 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
		
		/**
		 *
		 * Class reference.
		 */
		StageClass.main.scene.layerActions.effectEnd('index', 'before');
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(29).call(this.frame_29).wait(30).call(this.frame_59).wait(1));

	// logo
	this.instance = new lib.logo_1();
	this.instance.setTransform(726.65,360.1);
	this.instance.alpha = 0;
	this.instance._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1).to({_off:false},0).to({alpha:1},28).wait(1).to({alpha:0},29).wait(1));

	// button
	this.btn_start = new lib.button();
	this.btn_start.name = "btn_start";
	this.btn_start.setTransform(952.25,795.4);
	this.btn_start._off = true;
	new cjs.ButtonHelper(this.btn_start, 0, 1, 2, false, new lib.button(), 3);

	this.timeline.addTween(cjs.Tween.get(this.btn_start).wait(29).to({_off:false},0).to({_off:true},2).wait(29));

	// menu
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#00FF00").beginStroke().moveTo(-64,64).lineTo(-64,-64).lineTo(64,-64).lineTo(64,64).closePath();
	this.shape.setTransform(952.25,795.4);
	this.shape._off = true;

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(29).to({_off:false},0).to({_off:true},2).wait(29));

	// size
	this.instance_1 = new lib.size_1920x1080();
	this.instance_1.setTransform(960,540,1,1,0,0,0,960,540);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(60));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,1920,1080);


(lib.marker = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"frame01":1,"frame02":2,"frame03":3,"frame04":4,"frame05":5,"frame06":6,"frame07":7,"frame08":8,"frame09":9,"frame10":10};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_0 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(11));

	// arrow_up
	this.occ_animate = new lib.effect_up();
	this.occ_animate.name = "occ_animate";
	this.occ_animate.setTransform(38.45,0);
	this.occ_animate._off = true;

	this.timeline.addTween(cjs.Tween.get(this.occ_animate).wait(2).to({_off:false},0).wait(1).to({x:190.95},0).wait(1).to({x:372.4},0).wait(1).to({x:552.8},0).wait(1).to({x:744.15},0).wait(1).to({x:962.7},0).wait(1).to({x:1153.9},0).wait(1).to({x:1323.4},0).wait(1).to({x:1480.8},0).wait(1));

	// size
	this.instance = new lib.size_90x90();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(11));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,1503.4,90);


(lib.content_frame_02 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// button
	this.btn_page12 = new lib.button();
	this.btn_page12.name = "btn_page12";
	this.btn_page12.setTransform(1855.3,1039.05,0.6905,0.4688,0,0,0,0.7,0.1);
	new cjs.ButtonHelper(this.btn_page12, 0, 1, 2, false, new lib.button(), 3);

	this.btn_page11 = new lib.button();
	this.btn_page11.name = "btn_page11";
	this.btn_page11.setTransform(1715.7,1039.05,1.2568,0.4688,0,0,0,0.5,0.1);
	new cjs.ButtonHelper(this.btn_page11, 0, 1, 2, false, new lib.button(), 3);

	this.btn_page10 = new lib.button();
	this.btn_page10.name = "btn_page10";
	this.btn_page10.setTransform(1572.3,1039.05,0.6905,0.4688,0,0,0,0.7,0.1);
	new cjs.ButtonHelper(this.btn_page10, 0, 1, 2, false, new lib.button(), 3);

	this.btn_page09 = new lib.button();
	this.btn_page09.name = "btn_page09";
	this.btn_page09.setTransform(1454.15,1039.05,0.8733,0.4688,0,0,0,1.2,0.1);
	new cjs.ButtonHelper(this.btn_page09, 0, 1, 2, false, new lib.button(), 3);

	this.btn_page08 = new lib.button();
	this.btn_page08.name = "btn_page08";
	this.btn_page08.setTransform(1335.95,1039.05,0.6726,0.4688,0,0,0,0.6,0.1);
	new cjs.ButtonHelper(this.btn_page08, 0, 1, 2, false, new lib.button(), 3);

	this.btn_page07 = new lib.button();
	this.btn_page07.name = "btn_page07";
	this.btn_page07.setTransform(1219.65,1039.05,0.853,0.4688,0,0,0,0.4,0.1);
	new cjs.ButtonHelper(this.btn_page07, 0, 1, 2, false, new lib.button(), 3);

	this.btn_page06 = new lib.button();
	this.btn_page06.name = "btn_page06";
	this.btn_page06.setTransform(1038.1,1039.05,1.6982,0.4688,0,0,0,0.4,0.1);
	new cjs.ButtonHelper(this.btn_page06, 0, 1, 2, false, new lib.button(), 3);

	this.btn_page05 = new lib.button();
	this.btn_page05.name = "btn_page05";
	this.btn_page05.setTransform(824,1039.05,1.3514,0.4688,0,0,0,0.3,0.1);
	new cjs.ButtonHelper(this.btn_page05, 0, 1, 2, false, new lib.button(), 3);

	this.btn_page04 = new lib.button();
	this.btn_page04.name = "btn_page04";
	this.btn_page04.setTransform(640.7,1039.05,1.2194,0.4688,0,0,0,0.2,0.1);
	new cjs.ButtonHelper(this.btn_page04, 0, 1, 2, false, new lib.button(), 3);

	this.btn_page03 = new lib.button();
	this.btn_page03.name = "btn_page03";
	this.btn_page03.setTransform(459.25,1039.05,1.3249,0.4688,0,0,0,0.2,0.1);
	new cjs.ButtonHelper(this.btn_page03, 0, 1, 2, false, new lib.button(), 3);

	this.btn_page02 = new lib.button();
	this.btn_page02.name = "btn_page02";
	this.btn_page02.setTransform(312.95,1039.05,0.6687,0.4688,0,0,0,0.2,0.1);
	new cjs.ButtonHelper(this.btn_page02, 0, 1, 2, false, new lib.button(), 3);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.btn_page02},{t:this.btn_page03},{t:this.btn_page04},{t:this.btn_page05},{t:this.btn_page06},{t:this.btn_page07},{t:this.btn_page08},{t:this.btn_page09},{t:this.btn_page10},{t:this.btn_page11},{t:this.btn_page12}]}).wait(1));

	// button_logo
	this.btn_back = new lib.button();
	this.btn_back.name = "btn_back";
	this.btn_back.setTransform(105.4,1040.05,1.9531,0.625,0,0,0,0.2,0.1);
	this.btn_back.visible = false;
	new cjs.ButtonHelper(this.btn_back, 0, 1, 2, false, new lib.button(), 3);

	this.timeline.addTween(cjs.Tween.get(this.btn_back).wait(1));

	// marker
	this.occ_marker = new lib.marker();
	this.occ_marker.name = "occ_marker";
	this.occ_marker.setTransform(270,1080);

	this.timeline.addTween(cjs.Tween.get(this.occ_marker).wait(1));

	// marker_slider
	this.occ_marker_slider = new lib.arrow_up();
	this.occ_marker_slider.name = "occ_marker_slider";
	this.occ_marker_slider.setTransform(308.45,1057.35);
	this.occ_marker_slider.visible = false;

	this.timeline.addTween(cjs.Tween.get(this.occ_marker_slider).wait(1));

	// pseudo
	this.instance = new lib.pseudo();
	this.instance.setTransform(0,-120.75);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// title
	this.instance_1 = new lib.title();
	this.instance_1.setTransform(280,1026.4);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1));

	// logo
	this.occ_logo = new lib.logo_2();
	this.occ_logo.name = "occ_logo";
	this.occ_logo.setTransform(47,1000);
	this.occ_logo.visible = false;

	this.timeline.addTween(cjs.Tween.get(this.occ_logo).wait(1));

	// background
	this.instance_2 = new lib.background();
	this.instance_2.setTransform(0,1000);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(1));

	// background_dynamic
	this.occ_dynamic = new lib.background_dynamic();
	this.occ_dynamic.name = "occ_dynamic";
	this.occ_dynamic.visible = false;

	this.timeline.addTween(cjs.Tween.get(this.occ_dynamic).wait(1));

	// size
	this.instance_3 = new lib.size_1920x1080();

	this.timeline.addTween(cjs.Tween.get(this.instance_3).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.content_frame_02, new cjs.Rectangle(-20,-120.7,1942,1290.7), null);


// stage content:
(lib.index = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"frame01":1,"frame02":2};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	this.actionFrames = [0,1];
	// timeline functions:
	this.frame_0 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
		
		/**
		 *
		 * Class reference.
		 */
		StageClass.main.scene.layerActions.frame01Index(this, 'index');
	}
	this.frame_1 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(1).call(this.frame_1).wait(2));

	// ContentFrame
	this.occ_frame_01 = new lib.content_frame_01();
	this.occ_frame_01.name = "occ_frame_01";

	this.occ_frame_02 = new lib.content_frame_02();
	this.occ_frame_02.name = "occ_frame_02";

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.occ_frame_01}]},1).to({state:[{t:this.occ_frame_02}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new lib.AnMovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,1922,1170);
// library properties:
lib.properties = {
	id: '8D6FF2B23DC06844BB2994587C24925D',
	width: 1920,
	height: 1080,
	fps: 30,
	color: "#FFFFFF",
	opacity: 0.00,
	manifest: [
		{src:"./images/index_atlas_1.png?1738064353491", id:"index_atlas_1"}
	],
	preloads: []
};



// bootstrap callback support:

(lib.Stage = function(canvas) {
	createjs.Stage.call(this, canvas);
}).prototype = p = new createjs.Stage();

p.setAutoPlay = function(autoPlay) {
	this.tickEnabled = autoPlay;
}
p.play = function() { this.tickEnabled = true; this.getChildAt(0).gotoAndPlay(this.getTimelinePosition()) }
p.stop = function(ms) { if(ms) this.seek(ms); this.tickEnabled = false; }
p.seek = function(ms) { this.tickEnabled = true; this.getChildAt(0).gotoAndStop(lib.properties.fps * ms / 1000); }
p.getDuration = function() { return this.getChildAt(0).totalFrames / lib.properties.fps * 1000; }

p.getTimelinePosition = function() { return this.getChildAt(0).currentFrame / lib.properties.fps * 1000; }

an.bootcompsLoaded = an.bootcompsLoaded || [];
if(!an.bootstrapListeners) {
	an.bootstrapListeners=[];
}

an.bootstrapCallback=function(fnCallback) {
	an.bootstrapListeners.push(fnCallback);
	if(an.bootcompsLoaded.length > 0) {
		for(var i=0; i<an.bootcompsLoaded.length; ++i) {
			fnCallback(an.bootcompsLoaded[i]);
		}
	}
};

an.compositions = an.compositions || {};
an.compositions['8D6FF2B23DC06844BB2994587C24925D'] = {
	getStage: function() { return exportRoot.stage; },
	getLibrary: function() { return lib; },
	getSpriteSheet: function() { return ss; },
	getImages: function() { return img; }
};

an.compositionLoaded = function(id) {
	an.bootcompsLoaded.push(id);
	for(var j=0; j<an.bootstrapListeners.length; j++) {
		an.bootstrapListeners[j](id);
	}
}

an.getComposition = function(id) {
	return an.compositions[id];
}


an.makeResponsive = function(isResp, respDim, isScale, scaleType, domContainers) {		
	var lastW, lastH, lastS=1;		
	window.addEventListener('resize', resizeCanvas);		
	resizeCanvas();		
	function resizeCanvas() {			
		var w = lib.properties.width, h = lib.properties.height;			
		var iw = document.documentElement.clientWidth, ih = document.documentElement.clientHeight;			
		var pRatio = window.devicePixelRatio || 1, xRatio=iw/w, yRatio=ih/h, sRatio=1;			
		if(isResp) {                
			if((respDim=='width'&&lastW==iw) || (respDim=='height'&&lastH==ih)) {                    
				sRatio = lastS;                
			}				
			else if(!isScale) {					
				if(iw<w || ih<h)						
					sRatio = Math.min(xRatio, yRatio);				
			}				
			else if(scaleType==1) {					
				sRatio = Math.min(xRatio, yRatio);				
			}				
			else if(scaleType==2) {					
				sRatio = Math.max(xRatio, yRatio);				
			}			
		}
		domContainers[0].width = w * pRatio * sRatio;			
		domContainers[0].height = h * pRatio * sRatio;
		domContainers.forEach(function(container) {				
			container.style.width = w * sRatio + 'px';				
			container.style.height = h * sRatio + 'px';			
		});
		stage.scaleX = pRatio*sRatio;			
		stage.scaleY = pRatio*sRatio;
		lastW = iw; lastH = ih; lastS = sRatio;            
		stage.tickOnUpdate = false;            
		stage.update();            
		stage.tickOnUpdate = true;		
	}
}
an.handleSoundStreamOnTick = function(event) {
	if(!event.paused){
		var stageChild = stage.getChildAt(0);
		if(!stageChild.paused || stageChild.ignorePause){
			stageChild.syncStreamSounds();
		}
	}
}
an.handleFilterCache = function(event) {
	if(!event.paused){
		var target = event.target;
		if(target){
			if(target.filterCacheList){
				for(var index = 0; index < target.filterCacheList.length ; index++){
					var cacheInst = target.filterCacheList[index];
					if((cacheInst.startFrame <= target.currentFrame) && (target.currentFrame <= cacheInst.endFrame)){
						cacheInst.instance.cache(cacheInst.x, cacheInst.y, cacheInst.w, cacheInst.h);
					}
				}
			}
		}
	}
}


})(createjs = createjs||{}, AdobeAn = AdobeAn||{});
